module.exports = __webpack_public_path__ + "static/media/bg-footer.eba77365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EnergyCompany/img/bg-footer.png
// module id = 991
// module chunks = 0